export default __webpack_public_path__ + "static/media/faq-header-icon.f35bfaea.svg";